module.exports = __webpack_public_path__ + "static/img/direct324.6faaf3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/direct324.jpg
// module id = 3W//
// module chunks = 3